import { useContext } from 'react';

import { CMSProviderContext } from '../contexts/CMSContext';

import { UseContentSelector } from './selectors';

export interface UseOptionalContentResult<T> {
  isFetching: boolean;
  data?: T;
  error?: Error;
  refresh: () => Promise<void>;
}

export const useOptionalContent = <Result, Transformed>({
  useResultSelector,
  useDataSelector,
}: UseContentSelector<Result, Transformed>): UseOptionalContentResult<Transformed> => {
  const context = useContext(CMSProviderContext);

  if (!context) {
    throw new Error('useOptionalContent was used without a matching Provider available');
  }

  const { data, refresh, error, isFetching } = useResultSelector(context);

  const transformed = useDataSelector(data);

  return {
    data: transformed,
    error,
    isFetching,
    refresh,
  };
};
